/** @format */

import {styled} from '@mui/material/styles';
import {MenuItem} from '@mui/material';

export const StyledMenuItem = styled(MenuItem)(({theme}) => ({
  height: '48px',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 4),
  background: theme.palette.figma_gray_light_4?.main,
  color: theme.palette.figma_gray_dark_5?.main,

  fontWeight: 400,
  lineHeight: '20px',

  '.MuiSvgIcon-root': {
    fontSize: '16px',
  },

  '&:hover': {
    background: '#e2e3e6',
    color: theme.palette.figma_gray_dark_5?.main,
  },

  '&:active': {
    background: theme.palette.figma_surface_muted?.main,
    color: theme.palette.figma_gray_dark_5?.main,
  },
}));
